<template>
  <div>
    <img v-if="shouldShow" :src="this.getImageSrc()" :alt="title" style="width: 100%">
  </div>
</template>

<script>
export default {
  name: 'TextDisplay',
  props: {
    image: String,
    title: String
  },
  methods: {
    getImageSrc() {
      return "data:image/png;base64, " + this.image;
    },
    shouldShow() {
      return this.image !== "";
    }
  }
}
</script>
